import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { COMPANY } from "@/config/site";

// SEO léger côté client : title, meta description, canonical, OG, JSON-LD
const Seo = ({ title, description, path = "/", jsonLd = null, noindex = false }) => {
  const location = useLocation();
  const currentPath = path || location.pathname;

  useEffect(() => {
    document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [kind, key] = selector
          .replace("meta[", "")
          .replace("]", "")
          .split("=");
        el.setAttribute(kind, key.replace(/"/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", `${COMPANY.url}${currentPath}`);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:site_name"]', "content", COMPANY.name);
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta(
      'meta[name="robots"]',
      "content",
      noindex ? "noindex, nofollow" : "index, follow"
    );

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${COMPANY.url}${currentPath}`);

    let ld = document.getElementById("jsonld-page");
    if (ld) ld.remove();
    if (jsonLd) {
      ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.id = "jsonld-page";
      ld.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(ld);
    }
  }, [title, description, currentPath, jsonLd, noindex]);

  return null;
};

// JSON-LD Organisation réutilisable
export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "MovingCompany",
  "@id": `${COMPANY.url}/#organization`,
  name: COMPANY.name,
  url: COMPANY.url,
  email: COMPANY.email,
  telephone: COMPANY.phoneIntl,
  address: {
    "@type": "PostalAddress",
    streetAddress: COMPANY.address,
    postalCode: COMPANY.postalCode,
    addressLocality: COMPANY.city,
    addressCountry: "FR",
  },
  areaServed: ["France", "Belgique", "Pays-Bas", "Luxembourg", "Allemagne", "Espagne", "Italie", "Portugal", "Suisse"],
  foundingDate: "2022-07-01",
  legalName: `${COMPANY.name} SAS`,
  taxID: COMPANY.tva,
  openingHours: ["Mo-Fr 08:00-18:00", "Sa 09:00-12:00"],
};

export default Seo;
